import ComponentsList from './components_list'

const Callinputs = ({ component, value, ...rest }: any) => {
  if (component && typeof component === 'object') {
    return component
  }

  const Component = (ComponentsList as any)[component]

  if (!Component) {
    return null
  }

  return <Component {...rest} value={value || ''} />
}

export default Callinputs
